export default __webpack_public_path__ + "dcc8ff76aa2dc9dc5b91e75a6e3feb6b.png";